var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthorizationUtilization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 16.6667V10.8333M10.0002 16.6667V8.33333M3.3335 16.6667L3.3335 13.3333M11.1724 4.18959L15.4794 5.80473M8.99914 4.50077L4.33369 7.99986M17.5507 5.36612C18.0389 5.85427 18.0389 6.64573 17.5507 7.13388C17.0626 7.62204 16.2711 7.62204 15.7829 7.13388C15.2948 6.64573 15.2948 5.85427 15.7829 5.36612C16.2711 4.87796 17.0626 4.87796 17.5507 5.36612ZM4.21738 7.86612C4.70553 8.35427 4.70553 9.14573 4.21738 9.63388C3.72922 10.122 2.93777 10.122 2.44961 9.63388C1.96146 9.14573 1.96146 8.35427 2.44961 7.86612C2.93777 7.37796 3.72922 7.37796 4.21738 7.86612ZM10.884 2.86612C11.3722 3.35427 11.3722 4.14573 10.884 4.63388C10.3959 5.12204 9.60443 5.12204 9.11628 4.63388C8.62812 4.14573 8.62812 3.35427 9.11628 2.86612C9.60443 2.37796 10.3959 2.37796 10.884 2.86612Z",
    stroke: "#475467",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizationUtilization);
export default __webpack_public_path__ + "static/media/authorizationUtilization.716e9e9a1b0fc778ca9feea58aa10dc4.svg";
export { ForwardRef as ReactComponent };